import urls from './urls.js';
import global from './global.js';
import base from './base.js';
import loading from './loading.js';
import base64 from './base64.js';

export default {
	...urls,
	global,
	...base,
	...loading,
	base64,
};